module.exports = __webpack_public_path__ + "img/Portafolio MiloHealth_3.f2236240.png";